var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3V7.6875L12.5 7.73851C12.4999 8.13607 12.4998 8.52244 12.5427 8.84111C12.591 9.20036 12.7087 9.61031 13.0492 9.95083C13.3897 10.2913 13.7996 10.409 14.1589 10.4573C14.4776 10.5002 14.8639 10.5001 15.2615 10.5H15.2615L15.3125 10.5H20V16.125C20 18.7766 20 20.1025 19.1762 20.9262C18.3525 21.75 17.0267 21.75 14.375 21.75H10.625C7.97335 21.75 6.64752 21.75 5.82376 20.9262C5 20.1025 5 18.7766 5 16.125V8.625C5 5.97335 5 4.64752 5.82376 3.82376C6.64752 3 7.97335 3 10.625 3H12.5ZM14.375 3.00433V7.6875C14.375 8.15594 14.377 8.41297 14.401 8.59127L14.4019 8.5981L14.4087 8.59904C14.587 8.62301 14.8441 8.625 15.3125 8.625H19.9957C19.9861 8.23909 19.9555 7.98371 19.8573 7.74662C19.7145 7.40205 19.4436 7.13108 18.9017 6.58916L18.9017 6.58915L16.4108 4.09835C15.8689 3.55642 15.598 3.28545 15.2534 3.14273C15.0163 3.04452 14.7609 3.01389 14.375 3.00433Z",
    fill: "#B0AFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/Guide.ff74c732fc801fa97f80ffbe20844991.svg";
export { ForwardRef as ReactComponent };